import axiosInstance from "../../../core/api/axios";
import { useEssayCoreStore } from "../../../core/stores/essayCoreStore";
import { CheckAnswerBody } from "../model/dto";
import { practiceConfigStore } from "../stores/practiceConfigStore";

export const setAnswer = async (answer: string, question: string, simulated: string) => {
  try {
    const { data } = await axiosInstance.post(`/examsimulator/answer`, { answer, question, simulated })

    return data;
  } catch(e: any) {
    throw new Error(e)
  }
}

export const setExercises = async () => {
  try {
    const areasFilter = practiceConfigStore.getState().areasFilter;
    const courseId = practiceConfigStore.getState().courseId;
    const courseWeekId = practiceConfigStore.getState().courseWeekId;
    const cronometer = practiceConfigStore.getState().cronometer;
    const difficulty = practiceConfigStore.getState().difficulty;
    const hasVideoResolution = practiceConfigStore.getState().hasVideoResolution;
    const questionsNumber = practiceConfigStore.getState().questionsNumber;
    const simulationType = practiceConfigStore.getState().simulationType;
    const institutionType = practiceConfigStore.getState().institutionType;
    const essayCorrectionType = practiceConfigStore.getState().essayCorrectionType;
    const hasEssay = practiceConfigStore.getState().hasEssay;
    const essayThemeAxis = practiceConfigStore.getState().essayThemeAxis;
    const hasntDone = practiceConfigStore.getState().hasntDone;
    const selectedYear = practiceConfigStore.getState().selectedYear;

    const essayPart = {
      essayCorrectionType,
      hasEssay,
      essayThemeAxis
    }
    
    const { data } = await axiosInstance.post(`/examsimulator/exercises`, {
      areasFilter,
      courseId,
      courseWeekId,
      cronometer,
      difficulty: difficulty,
      hasVideoResolution,
      questionsNumber,
      simulationType,
      institutionType: institutionType.length > 0 ? institutionType : undefined,
      year: selectedYear.length > 0 ? selectedYear : undefined,
      excludeAnsweredQuestions: hasntDone,
      ...hasEssay && essayPart
    })

    return data;
  } catch(e: any) {
    throw new Error(e)
  }
}

export const startPractice = async () => {
  try {
    const areasFilter = practiceConfigStore.getState().areasFilter;
    const courseId = practiceConfigStore.getState().courseId;
    const courseWeekId = practiceConfigStore.getState().courseWeekId;
    const cronometer = practiceConfigStore.getState().cronometer;
    const difficulty = practiceConfigStore.getState().difficulty;
    const hasVideoResolution = practiceConfigStore.getState().hasVideoResolution;
    const questionsNumber = practiceConfigStore.getState().questionsNumber;
    const simulationType = practiceConfigStore.getState().simulationType;
    const institutionType = practiceConfigStore.getState().institutionType;
    const essayCorrectionType = practiceConfigStore.getState().essayCorrectionType;
    const hasEssay = practiceConfigStore.getState().hasEssay;
    const essayThemeAxis = practiceConfigStore.getState().essayThemeAxis;
    const hasntDone = practiceConfigStore.getState().hasntDone;
    const title = practiceConfigStore.getState().title;
    const selectedYear = practiceConfigStore.getState().selectedYear;
    const reset = practiceConfigStore.getState().resetConfig;
    const resetEssay = useEssayCoreStore.getState().reset;

    const essayPart = {
      essayCorrectionType,
      hasEssay,
      essayThemeAxis
    }

    const { data } = await axiosInstance.post(`/examsimulator`, {
      areasFilter,
      courseId,
      courseWeekId,
      cronometer,
      difficulty,
      hasVideoResolution,
      questionsNumber,
      simulationType,
      year: selectedYear.length > 0 ? selectedYear : undefined,
      excludeAnsweredQuestions: hasntDone,
      title,
      institutionType: institutionType.length > 0 ? institutionType : undefined,
      ...hasEssay && essayPart
    })

    if (data?.ok && data?.simulatedExamId) {
      if (hasEssay) {
        resetEssay();
      }
      reset();
    }

    return data;
  } catch(e: any) {
    throw new Error(e)
  }
}

export const finishPractice = async (id: string) => {
  try {
    const { data } = await axiosInstance.post(`/examsimulator/finish/${id}`)

    return data;
  } catch(e: any) {
    throw new Error(e)
  }
}

export const deletePractice = async (id: string) => {
  try {
    const { data } = await axiosInstance.put(`/examsimulator/delete/${id}`)

    return data;
  } catch(e: any) {
    throw new Error(e)
  }
}

export const deleteManyPractices = async (ids: string[]) => {
  try {
    const { data } = await axiosInstance.put(`/examsimulator/delete`, { ids })

    return data;
  } catch(e: any) {
    throw new Error(e)
  }
}

export const updatePractice = async (id: string, title: string) => {
  try {
    const { data } = await axiosInstance.put(`/examsimulator/${id}/title`, { title })

    return data;
  } catch(e: any) {
    throw new Error(e)
  }
}

export const deleteRevision = async (id: string) => {
  try {
    const { data } = await axiosInstance.put(`/examsimulator/revision/${id}/hide`)

    return data;
  } catch(e: any) {
    throw new Error(e)
  }
}

export const remakePractice = async (id: string) => {
  try {
    const { data } = await axiosInstance.post(`/examsimulator/remake/${id}`)

    return data;
  } catch(e: any) {
    throw new Error(e)
  }
}

export const checkAnswer = async (body: CheckAnswerBody, id: string) => {
  try {
    const { data } = await axiosInstance.post(`/examsimulator/revision/${id}/check`, body)

    return data;
  } catch(e: any) {
    throw new Error(e)
  }
}

export const finishRevision = async(id: string) => {
  try {
    const { data } = await axiosInstance.post(`/examsimulator/revision/${id}/finish`)

    return data;
  } catch(e: any) {
    throw new Error(e)
  }
}

export const newAttemptRevision = async(id: string) => {
  try {
    const { data } = await axiosInstance.post(`/examsimulator/revision/${id}/finish?forceNewDate=true`)

    return data;
  } catch(e: any) {
    throw new Error(e)
  }
}